/**
 * Indicates where response insertions were generated by Promoted.
 */
export enum ExecutionServer {
  /**
   * Response insertions were generated by the Promoted API service.
   */
  API = 1,

  /**
   * Response insertions were generated on the client side by the Promoted SDK.
   */
  SDK = 2,
}
